module.exports = __webpack_public_path__ + "media/images/companies/ctv-e281697317e36849f0850b0fe66c6eac.png";